import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const loc = useLocation();
  const nav = [
    { href: '/', label: '連携状況' },
    { href: '/reports', label: '月次レポート' },
    { href: '/requests', label: '設定変更依頼' },
    { href: '/support', label: 'サポート' },
  ];

  if (loc.pathname === '/login') return null;

  return (
    <header className="bg-white border-b shadow-sm">
      <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
        <div>
          <h1 className="text-lg font-bold text-slate-900">Cogneolink</h1>
          <p className="text-xs text-slate-500">あなたのデータ連携ポータル</p>
        </div>
        <nav className="flex gap-4">
          {nav.map((n) => (
            <Link
              key={n.href}
              to={n.href}
              className={`text-sm px-3 py-2 rounded transition ${
                loc.pathname === n.href
                  ? 'bg-blue-100 text-blue-700 font-medium'
                  : 'text-slate-600 hover:text-slate-900'
              }`}
            >
              {n.label}
            </Link>
          ))}
        </nav>
      </div>
    </header>
  );
}
